var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M123.4,56.3h-4.7c-2.5-8.5-8.9-14.6-16.5-15.5c0.3-0.4,0.5-0.9,0.5-1.5c0-1.3-1.1-2.3-2.3-2.3c-1.3,0-2.3,1.1-2.3,2.3 c0,0.5,0.2,1.1,0.5,1.5c-7.8,0.9-14.2,7.1-16.8,15.5h-4.1v3.9h45.7V56.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 64.2,
    width: 76.9,
    height: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7,
    cy: 14.8,
    r: 12.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3,73H39.6V57.6L28.9,39.3c-0.4-0.7-0.1-1.7,0.5-2.1c0.7-0.4,1.7-0.1,2.1,0.5l12.3,21.2c0.9,1.6,2.6,2.7,4.6,2.7h21.2 c3,0,5.4-2.5,5.4-5.4c0-3-2.5-5.4-5.4-5.4L51.9,51L37.8,27.2c-1-1.9-3.1-2.9-5.6-2.9c-0.3,0-1.1,0.1-1.5,0.2 c-0.3,0.1-0.8,0.2-1.1,0.3C19.2,28.2,11,44.6,11,61.5c-0.1,5.1,0,9.4,0.3,13.5c-0.4,4.9,2.5,9.7,7.3,11.5c1.3,0.4,2.5,0.7,3.8,0.7 h30.9v28.9c0,4,3.1,7,7,7c4,0,7-3.1,7-7v-36c0-1.8-0.7-3.7-2.1-4.9C63.8,73.8,62,73,60.3,73z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinner);
export default __webpack_public_path__ + "static/media/dinner.9cd2b4f335c92c5ba9449a707c8247d1.svg";
export { ForwardRef as ReactComponent };